var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("支付详情"),
      visible: _vm.dialogVisible,
      footer: null,
      width: 820
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    attrs: {
      model: _vm.dataFrom,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-row", {
    staticStyle: {
      display: "flex",
      "flex-wrap": "wrap"
    }
  }, [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("交易订单号")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.tradeNo,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "tradeNo", $$v);
      },
      expression: "dataFrom.tradeNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("订单号")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.orderNo,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "orderNo", $$v);
      },
      expression: "dataFrom.orderNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付方式")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.payTypeName,
      callback: function ($$v) {
        _vm.payTypeName = $$v;
      },
      expression: "payTypeName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("订单金额")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.totalFee,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "totalFee", $$v);
      },
      expression: "dataFrom.totalFee"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付金额")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.paymentAmount,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "paymentAmount", $$v);
      },
      expression: "dataFrom.paymentAmount"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付来源")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.appName,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "appName", $$v);
      },
      expression: "dataFrom.appName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付场景")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.typeName,
      callback: function ($$v) {
        _vm.typeName = $$v;
      },
      expression: "typeName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("收款账号")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.account,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "account", $$v);
      },
      expression: "dataFrom.account"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("账号主体")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.intermediaryName,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "intermediaryName", $$v);
      },
      expression: "dataFrom.intermediaryName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付时间")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.dataFrom.paymentAt,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "paymentAt", $$v);
      },
      expression: "dataFrom.paymentAt"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("支付状态")
    }
  }, [_c("a-input", {
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.payStatusName,
      callback: function ($$v) {
        _vm.payStatusName = $$v;
      },
      expression: "payStatusName"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };